export default {
    title_list: 'Тарифные планы',
    title_page: 'Тарифный план',
    title_create_page: 'Создать тарифный план',
    title_edit_page: 'Изменить тарифный план',

    labels: {
        permissions_table: 'Разрешения',
        permission: 'Разрешение',
        value: 'Значение',
        select_permission: 'Выбрать разрешение',
        add_permission: 'Добавить разрешение',
        plan_updated: 'Тарифные планы обновлены',
    },

    filter: {
        labels: {
            title: 'Название',
            slug: 'Braintree ID',
        }
    },

    table: {
        labels: {
            id: 'ID',
            slug: 'Braintree ID',
            title: 'Название',
            price: 'Стоимость',
            active: 'Отображается',
        }
    },

    buttons: {
        update_plans: 'Синхронизация с Braintree'
    },

    form: {
        slug: 'Braintree ID',
        title: 'Название',
        promo_label: 'Промо подпись',
        price: 'Стоимость',
        position: 'Порядок',
        active: 'Отображается для покупки',
        priority: 'Приоритет',
    },
}
